import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mdType'
})
export class MdTypePipe implements PipeTransform {

  transform(mdtype: string) {
    
  }

}
